import { useEffect } from "react";

const useFocusTrap = (isOpen, modalRef) => {
    useEffect(() => {
        if (!isOpen || !modalRef.current) return;

        let focusableElements = [];

        const updateFocusableElements = () => {
            const standardSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

            const standardElements = Array.from(
                modalRef.current.querySelectorAll(standardSelector)
            ).filter(element => element.offsetParent !== null);

            const pdfViewerElement = modalRef.current.querySelector('.ok-pdf-viewer__document-container');

            if (pdfViewerElement && pdfViewerElement.offsetParent !== null) {
                if (!pdfViewerElement.getAttribute('tabindex')) {
                    pdfViewerElement.setAttribute('tabindex', '0');
                }

                if (!standardElements.includes(pdfViewerElement)) {
                    standardElements.push(pdfViewerElement);
                }
            }

            focusableElements = standardElements;
        };

        updateFocusableElements();

        const firstElement = () => focusableElements[0];
        const lastElement = () => focusableElements[focusableElements.length - 1];

        if (firstElement()) {
            firstElement().focus();
        } else {
            modalRef.current.focus();
        }

        const handleKeyDown = (e) => {
            if (e.key !== "Tab") return;

            if (focusableElements.length === 0) return;

            if (e.shiftKey) {
                if (document.activeElement === firstElement()) {
                    e.preventDefault();
                    lastElement().focus();
                }
            } else {
                if (document.activeElement === lastElement()) {
                    e.preventDefault();
                    firstElement().focus();
                }
            }
        };

        const observer = new MutationObserver(updateFocusableElements);
        observer.observe(modalRef.current, { childList: true, subtree: true });

        modalRef.current.addEventListener("keydown", handleKeyDown);

        return () => {
            observer.disconnect();
            if (modalRef.current) {
                modalRef.current.removeEventListener("keydown", handleKeyDown);
            }
        };
    }, [isOpen, modalRef]);
};

export default useFocusTrap;
